'use client';

import { useState, useEffect } from 'react';
import CustomTable from '../../components/CustomTable';
import ModalTransportadora from './ModalTransportadora';
import ModalRetorno from '../../components/ModalRetorno';

interface TableProps {
  headers: any;
  onDelete: (selectedData: any[]) => void;
  dados: any[];
  valoPesquisa: string;
}

export default function TabelaTransportadora({ headers, onDelete, dados, valoPesquisa }: TableProps) {
  const [tableData, setTableData] = useState(dados);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const [modalRetornoOpen, setModalRetornoOpen] = useState(false);
  const [mensagemRetorno, setMensagemRetorno] = useState('');
  const [tipoRetorno, setTipoRetorno] = useState<'sucesso' | 'erro'>('sucesso');

  useEffect(() => {
    setTableData(dados);
  }, [dados]);

  const handleAddTransportadora = (data: any) => {
    if (data.rota && data.rota.trim() !== '') {
      setTableData(prevData => [
        ...prevData,
        { id: prevData.length + 1, rota: data.rota, ativo: true },
      ]);
      setIsModalOpen(false);
      setMensagemRetorno('Transportadora adicionada com sucesso!');
      setTipoRetorno('sucesso');
      setModalRetornoOpen(true);
    }
  };

  const handleDeleteRecords = (selectedData: any[]) => {
    const selectedIds = selectedData.map(item => item.id);
    const newData = tableData.filter(item => !selectedIds.includes(item.id));
    setTableData(newData);
    onDelete(selectedData);
    setMensagemRetorno('Transportadoras excluídas com sucesso!');
    setTipoRetorno('sucesso');
    setModalRetornoOpen(true);
  };

  const handleDataChange = (newData: any[]) => {
    setTableData(newData);
  };

  return (
    <>
      <CustomTable
        headers={headers}
        data={tableData}
        searchValue={valoPesquisa}
        onDelete={handleDeleteRecords}
        onAdd={() => setIsModalOpen(true)}
        onDataChange={handleDataChange}
        addButtonLabel="Adicionar"
        deleteButtonLabel="Excluir"
        showActions={true}
      />

      <ModalTransportadora
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        handleAddTransportadora={handleAddTransportadora}
      />

      <ModalRetorno
        isOpen={modalRetornoOpen}
        onClose={() => setModalRetornoOpen(false)}
        mensagem={mensagemRetorno}
        tipo={tipoRetorno}
      />
    </>
  );
}
